module.exports = __webpack_public_path__ + "static/media/logo-u-v2.69c0d8fc.svg";